import * as variables from './variables.js';

import './lib/AnimationEasing';

import {Analytics} from '@plaudit/analytics';
Analytics.getInstance({
    mirrorEvents: {
        microsoft: true     // Mirror events reported to GA to Microsoft's analytics (used for MS Ads)
	}
});

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import SearchForm from './component/HeaderSearchForm';
new SearchForm('.searchArea', '.searchArea__icon', '.searchArea__query', 'open');

import Forms from './component/Forms';
Forms.init();

import Gallery from './component/Gallery';
new Gallery();
